<template>
    <div class="btn-container">
        <v-btn
            class="btn-active"
            small
            tile
            color="#6c98ba"
            :disabled="disabled"
            @click="changeStatus(true)"
            :outlined="!status"
            width="100px"
            height="38px">
            {{ $vuetify.lang.t('$vuetify.toggleStatus.active') }}
        </v-btn>
        <v-btn
            class="btn-inactive"
            small
            tile
            color="#ff544a"
            :disabled="disabled"
            @click="changeStatus(false)"
            :outlined="status"
            width="100px"
            height="38px">
            {{ $vuetify.lang.t('$vuetify.toggleStatus.inactive') }}
        </v-btn>
    </div>
</template>

<script>
export default {
    name: 'ToggleStatus',

    props: {
        value: {
            type: Boolean,
            default: false
        },

        disabled: {
            type: Boolean,
            default: false
        }
    },

    data () {
        return {
            status: this.value,
            activeBtnColor: '',
            inactiveBtnColor: ''
        }
    },

    methods: {
        changeStatus (status) {
            this.status = status
            this.$emit('input', this.status)
        }
    },

    watch: {
        value (newValue, oldValue) {
            this.status = newValue
        }
    }
}
</script>

<style lang="scss" scoped>
.btn-container {
    display: flex;
    justify-content: center;

    .btn-active {
        color: white;
        border-radius: 20px 0px 0px 20px;
    }
    .btn-inactive {
        color: white;
        border-radius: 0px 20px 20px 0px;
    }
}
</style>
